/**
 * @generated SignedSource<<0e7b3053e164d5901e6af58b7a501d5e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type screenAnalytics_softwareReleasesVersionDetailIssueList_IssueListScreenAnalytics_jiraVersionReference$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ui_softwareReleasesVersionIssueWarningController_IssuesWarningCountProvider_jiraVersion">;
  readonly " $fragmentType": "screenAnalytics_softwareReleasesVersionDetailIssueList_IssueListScreenAnalytics_jiraVersionReference";
};
export type screenAnalytics_softwareReleasesVersionDetailIssueList_IssueListScreenAnalytics_jiraVersionReference$key = {
  readonly " $data"?: screenAnalytics_softwareReleasesVersionDetailIssueList_IssueListScreenAnalytics_jiraVersionReference$data;
  readonly " $fragmentSpreads": FragmentRefs<"screenAnalytics_softwareReleasesVersionDetailIssueList_IssueListScreenAnalytics_jiraVersionReference">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "screenAnalytics_softwareReleasesVersionDetailIssueList_IssueListScreenAnalytics_jiraVersionReference",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ui_softwareReleasesVersionIssueWarningController_IssuesWarningCountProvider_jiraVersion"
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "2dad59bd036f7e19ca923546c2912289";

export default node;
